import { render, staticRenderFns } from "./FifteenDaysPrabhidhikBibaran.vue?vue&type=template&id=76e9bbbe&scoped=true&"
import script from "./FifteenDaysPrabhidhikBibaran.vue?vue&type=script&lang=js&"
export * from "./FifteenDaysPrabhidhikBibaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9bbbe",
  null
  
)

export default component.exports